export default __webpack_public_path__ + "static/media/bva-p_logo.14376e10.png";